export default class InvoicePaymentLinkItem {
  id: string;

  link: string;

  createdBy: string;

  createdDate: string;

  constructor(obj: any = {}) {
    this.id = obj.id || null;
    this.link = obj.link || '';
    this.createdBy = obj.createdBy || '';
    this.createdDate = obj.createdDate || '';
  }
}
